import { Link } from "react-router-dom";
import { useI18n } from "@expertloop/i18n/react";
import type { MessageKey } from "@expertloop/i18n";

/** Ce qui attend un administrateur, avec l'écran qui permet d'y répondre. */
export interface AttentionItem {
	id: string;
	labelKey: MessageKey;
	count: number;
	/** Écran existant, ou `null` quand aucune destination ne traite ce cas. */
	to: string | null;
	/** Explication affichée lorsqu'aucune destination n'existe. */
	hintKey?: MessageKey;
}

interface AttentionSectionProps {
	items: AttentionItem[];
}

/**
 * Liste des points d'attention.
 *
 * Une ligne sans destination existante n'invente pas de lien : elle explique
 * pourquoi il n'y en a pas. Proposer un bouton qui ne mène nulle part serait
 * pire que ne rien proposer.
 */
export function AttentionSection({ items }: AttentionSectionProps) {
	const { t } = useI18n();
	const pending = items.filter((item) => item.count > 0);

	if (pending.length === 0) {
		return <p className="admin-overview__state">{t("adminOverview.attentionAllClear")}</p>;
	}

	return (
		<ul className="admin-overview__attention">
			{pending.map((item) => (
				<li key={item.id} className="admin-overview__attention-item">
					<span className="admin-overview__attention-count">{item.count}</span>
					<span className="admin-overview__attention-label">{t(item.labelKey)}</span>
					{item.to ? (
						<Link className="admin-overview__attention-link" to={item.to}>
							{t("adminOverview.review")}
						</Link>
					) : (
						item.hintKey && (
							<span className="admin-overview__attention-hint">{t(item.hintKey)}</span>
						)
					)}
				</li>
			))}
		</ul>
	);
}
